import React, { useEffect, useState } from "react";
import http from "../../services/http";
import { useSelector } from "react-redux";
import { MDBCard } from "mdbreact";
import Filters from "./Filters";
import StatisticsTable from "./StatisticsTable";
import SettingsModal from "./SettingsModal";
import moment from "moment";
import { CSVLink } from "react-csv";
import { sortData } from "./utils";

const NewStatisticsPage = () => {
  const choosedSiteId = useSelector((state) => state.app.choosedSiteId);

  const initialSettingsConfig = localStorage.getItem("settings-config")
    ? JSON.parse(localStorage.getItem("settings-config"))
    : {
        // columns: ["emailConfirmed", "fpSu", "fp4s", "fpFtd", "online"],
        columns: [],
        groups: ["utmsource"],
        filters: ["utm_content"],
      };

  const [filterForm, setFilterForm] = useState({
    // Age: "",
    // SubId: "",
    // UtmCampaign: "",
    // UtmSource: "",
    // WebId: "",
  });

  const [dateForm, setDateForm] = useState({
    from: moment().startOf("month").format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
  });

  const [settingsConfig, setSettingsConfig] = useState(initialSettingsConfig);

  const [data, setData] = useState([]);
  const [csvData, setCsvData] = useState([]);

  const [hidedRows, setHidedRows] = useState([]);

  const [isSettingsVisible, setIsSettingsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [groupingOptions, setGroupingOptions] = useState([]);
  const [loadingGrouping, setLoadingGrouping] = useState(true);

  const [grouping, setGrouping] = useState({
    first: "partner",
    second: "linkid",
    third: "webid",
  });

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: null
  });

  const tableConfig = settingsConfig.columns;

  useEffect(() => {
    loadGrouping();
  }, []);

  useEffect(() => {
    fetchInitialData();
  }, [choosedSiteId]);

  useEffect(() => {
    if (data.length > 0) {
      const formattedData = data.map(row => ({
        Grouping: row.grouping,
        Registrations: !tableConfig.includes("registrations") ? row.registration : undefined,
        FillProfiles: !tableConfig.includes("fillProfiles") ? row.fillProfile : undefined,
        Confirmed: !tableConfig.includes("emailConfirmed") ? row.emailConfirmed : undefined,
        Posted: !tableConfig.includes("posted") ? row.posted : undefined,
        SMS4: (choosedSiteId === 37 || choosedSiteId === 69) && !tableConfig.includes("sms4Plus35") ? row.sms4Plus35 : undefined,
        Online: !tableConfig.includes("online") ? Math.floor(row.online) : undefined,
        Sales: !tableConfig.includes("sales") ? row.sales : undefined,
        FTD: !tableConfig.includes("ftd") ? row.ftd : undefined,
        Turnover: !tableConfig.includes("turnover") ? row.turnover : undefined,
        Investment: !tableConfig.includes("investment") ? row.investment : undefined,
        Profit: !tableConfig.includes("profit") ? (row.turnover - row.investment).toFixed(2) : undefined,
        ROI: !tableConfig.includes("roi") ? (row.turnover / row.investment).toFixed(2) : undefined,
      }));
      setCsvData(formattedData);
    }
  }, [data, choosedSiteId, tableConfig]);

  const onChangeSetting = (configGroup, id) => {
    const currentConfigGroup = settingsConfig[configGroup].includes(id)
      ? settingsConfig[configGroup].filter((i) => i !== id)
      : [...settingsConfig[configGroup], id];

    const newSettingsConfig = {
      ...settingsConfig,
      [configGroup]: currentConfigGroup,
    };
    setSettingsConfig(newSettingsConfig);
    localStorage.setItem("settings-config", JSON.stringify(newSettingsConfig));
  };

  const toggleAllSelectSettings = (newConfig) => {
    setSettingsConfig(newConfig);
    localStorage.setItem("settings-config", JSON.stringify(newConfig));
  };

  const groupSettings = settingsConfig.groups;
  const fileterdGroupingOptions = groupingOptions.filter(
    (option) => !groupSettings.includes(option.value)
  );

  const groupParams = groupingOptions.map((option) => ({
    label: option.label,
    value: option.value,
  }));

  const loadGrouping = async () => {
    setLoadingGrouping(true);
    const { data } = await http.get("/reports/main3_grouping");
    setGroupingOptions(
      data.map((item) => ({
        label: item.text === "Path" ? "Landing" : item.text,
        value: item.value,
      }))
    );
    setLoadingGrouping(false);
  };

  const handleSubmit = async () => {
    fetchInitialData();
  };

  const fetchInitialData = async () => {
    setIsLoading(true);
    setHidedRows([]);
    try {
      const baseParams = {
        siteId: choosedSiteId,
        StartDate: dateForm.from,
        EndDate: dateForm.to,
        ...filterForm,
      };
      const { data } = await http.get("/reports/main3", {
        params: {
          grouping: grouping.first,
          ...baseParams,
        },
      });
      setData(data.filter((item) => item.grouping));
    } catch (err) {
      alert("Smonething went wrong");
    }
    setIsLoading(false);
  };

  const addToCSVData = (newData, parentGrouping = null) => {
    const formattedData = newData.map(row => ({
      Grouping: parentGrouping ? `${parentGrouping} > ${row.grouping}` : row.grouping,
      Registrations: !tableConfig.includes("registrations") ? row.registration : undefined,
      FillProfiles: !tableConfig.includes("fillProfiles") ? row.fillProfile : undefined,
      Confirmed: !tableConfig.includes("emailConfirmed") ? row.emailConfirmed : undefined,
      Posted: !tableConfig.includes("posted") ? row.posted : undefined,
      SMS4: (choosedSiteId === 37 || choosedSiteId === 69) && !tableConfig.includes("sms4Plus35") ? row.sms4Plus35 : undefined,
      Online: !tableConfig.includes("online") ? row.online : undefined,
      Sales: !tableConfig.includes("sales") ? row.sales : undefined,
      FTD: !tableConfig.includes("ftd") ? row.ftd : undefined,
      Turnover: !tableConfig.includes("turnover") ? row.turnover : undefined,
      Investment: !tableConfig.includes("investment") ? row.investment : undefined,
      Profit: !tableConfig.includes("profit") ? (row.turnover - row.investment).toFixed(2) : undefined,
      ROI: !tableConfig.includes("roi") ? (row.turnover / row.investment).toFixed(2) : undefined,
    }));

    setCsvData(prevData => {
      // Удаляем старые данные с тем же grouping
      const filteredData = prevData.filter(item => 
        !newData.some(newItem => item['Grouping'].includes(newItem.grouping))
      );

      if (!parentGrouping) {
        return [...filteredData, ...formattedData];
      }

      const parentIndex = filteredData.findIndex(item => {
        const parentPath = item['Grouping'].split(' > ').pop();
        return parentPath === parentGrouping;
      });
      
      if (parentIndex === -1) {
        return [...filteredData, ...formattedData];
      }

      return [
        ...filteredData.slice(0, parentIndex + 1),
        ...formattedData,
        ...filteredData.slice(parentIndex + 1)
      ];
    });
  };

  const handleExportClick = () => {
    setCsvData(prevData => [...prevData]);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const finalData = sortData(data, sortConfig);
  return (
    <div>
      <Filters
        groupingOptions={fileterdGroupingOptions}
        loadingGrouping={loadingGrouping}
        grouping={grouping}
        setGrouping={setGrouping}
        setIsSettingsVisible={setIsSettingsVisible}
        filtersConfig={settingsConfig.filters}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        dateForm={dateForm}
        setDateForm={setDateForm}
        handleSubmit={handleSubmit}
      />
      <div className="mb-3">
        <CSVLink
          data={csvData.filter(item => !hidedRows.includes(item['Grouping']))}
          filename={`statistics_${moment().format('DDMMYYYY')}.csv`}
          className="btn btn-primary"
          onClick={handleExportClick}
        >
          Export to CSV
        </CSVLink>
      </div>
      <MDBCard className="mb-5 p-2">
        <StatisticsTable
          data={[...finalData]}
          tableConfig={tableConfig}
          choosedSiteId={choosedSiteId}
          grouping={grouping}
          isLoading={isLoading}
          filterForm={filterForm}
          dateForm={dateForm}
          hidedRows={hidedRows}
          setHidedRows={setHidedRows}
          addToCSVData={addToCSVData}
          sortConfig={sortConfig}
          onSort={handleSort}
        />
      </MDBCard>
      <SettingsModal
        settingsConfig={settingsConfig}
        onChangeSetting={onChangeSetting}
        visible={isSettingsVisible}
        toggleAllSelectSettings={toggleAllSelectSettings}
        onClose={() => setIsSettingsVisible(false)}
        groupParams={groupParams.map((param) => ({
          label: param.label,
          id: param.value,
        }))}
      />
    </div>
  );
};

export default NewStatisticsPage;
